// extracted by mini-css-extract-plugin
export var stickyBannerArea = "blogStickyBanner-module--stickyBannerArea--24fc9";
export var stickyBannerArea__heading = "blogStickyBanner-module--stickyBannerArea__heading--c784e";
export var stickyBannerArea__link = "blogStickyBanner-module--stickyBannerArea__link--35ce3";